import { C, Canvas, Caption, Heading, PageSheet } from "./MockupParts";

const P = (n) => `/mockups/pages/${n}.png`;

const TAG_TL = new Set(["cr-cover", "cr-summary", "tool-interview", "tool-job"]);

const LAYOUT = {
  wide: {
    w: 1200, h: 627, head: { x: 64, y: 140, w: 360, size: 40 },
    sheets: [
      { n: "cr-summary", x: 465, y: 190, w: 192, rot: -6 },
      { n: "cr-cover", x: 515, y: 150, w: 220, rot: -1 },
      { n: "cl-1", x: 700, y: 185, w: 180, rot: 4 },
      { n: "perc", x: 860, y: 160, w: 175, rot: -2 },
      { n: "tool-job", x: 1010, y: 100, w: 128, rot: -4 },
      { n: "tool-interview", x: 1035, y: 180, w: 128, rot: 1 },
      { n: "tool-onboarding", x: 1055, y: 260, w: 128, rot: 5 },
    ],
    caps: [
      { x: 485, y: 500, w: 230, t: "Informe de consultoría · 20 páginas", align: "center" },
      { x: 700, y: 500, w: 175, t: "Checklist de acciones", align: "center" },
      { x: 870, y: 500, w: 150, t: "Contraste de percepciones", align: "center", sub: "CEO frente a equipo" },
      { x: 1010, y: 500, w: 180, t: "Herramientas incluidas", align: "center", sub: "Oferta de empleo · Guía de entrevista · Plan de onboarding" },
    ],
  },
  square: {
    w: 1080, h: 1080, head: { x: 72, y: 80, w: 900, size: 50 },
    sheets: [
      { n: "cr-summary", x: 40, y: 500, w: 205, rot: -7 },
      { n: "cr-cover", x: 100, y: 460, w: 235, rot: -1 },
      { n: "cl-1", x: 325, y: 500, w: 210, rot: 4 },
      { n: "perc", x: 540, y: 470, w: 210, rot: -2 },
      { n: "tool-job", x: 770, y: 440, w: 150, rot: -4 },
      { n: "tool-interview", x: 825, y: 515, w: 150, rot: 1 },
      { n: "tool-onboarding", x: 880, y: 590, w: 150, rot: 5 },
    ],
    caps: [
      { x: 75, y: 860, w: 260, t: "Informe de consultoría · 20 páginas", align: "center" },
      { x: 335, y: 860, w: 200, t: "Checklist de acciones", align: "center" },
      { x: 545, y: 860, w: 200, t: "Contraste de percepciones", align: "center", sub: "CEO frente a equipo" },
      { x: 775, y: 860, w: 260, t: "Herramientas incluidas", align: "center", sub: "Oferta de empleo · Guía de entrevista · Plan de onboarding" },
    ],
  },
};

const ThcIncluded = ({ size }) => (
  <div className="flex items-center gap-3" style={{ marginTop: size > 45 ? 22 : 18 }}>
    <img src={P("thc-cover")} alt="" style={{ width: 34, height: 48, borderRadius: 2, boxShadow: "0 4px 10px -4px rgba(8,80,65,.4)" }} />
    <span style={{ fontFamily: "Inter, sans-serif", fontSize: 14, color: C.forest, fontWeight: 600, lineHeight: 1.35 }}>
      Incluye el Talent Health Check completo
    </span>
  </div>
);

export const MockupConsulting = ({ format, innerRef }) => {
  const L = LAYOUT[format];
  return (
    <Canvas w={L.w} h={L.h} innerRef={innerRef}>
      <div className="absolute" style={{ left: L.head.x, top: L.head.y, width: L.head.w }}>
        <Heading
          size={L.head.size}
          title="Consultoría premium"
          subtitle="Informe + checklist + herramientas IA · sin acompañamiento continuo"
          price="397 €"
        />
        <ThcIncluded size={L.head.size} />
      </div>
      {L.sheets.map((s, i) => (
        <PageSheet key={s.n} src={P(s.n)} w={s.w} x={s.x} y={s.y} rot={s.rot} z={i + 1} tag={TAG_TL.has(s.n) ? "tl" : "br"} />
      ))}
      {L.caps.map((c) => (
        <Caption key={c.t} x={c.x} y={c.y} w={c.w} align={c.align}>
          {c.t}
          {c.sub && <div style={{ fontWeight: 500, color: "#64748B", fontSize: 11, marginTop: 3 }}>{c.sub}</div>}
        </Caption>
      ))}
    </Canvas>
  );
};
